import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { combineClassNames } from '@common/utils/combineClassNames';
import { Icon } from '@common/components/icon';

type Template = {
  id: string;
  title: string;
  color?: string;
  background_color?: string;
  icon?: string;
  thumbnail_path?: string;
};

type CreateButtonProps = {
  title?: string;
  item?: Template;
  onTemplateClick?: (templateId?: string) => void;
};

const ButtonTemplate = forwardRef<HTMLDivElement, CreateButtonProps & React.HTMLAttributes<HTMLDivElement>>(
  ({
  title = '',
  item,
    onTemplateClick,
    onClick, // This might come from Radix UI's DialogTrigger when wrapped in Modal
    ...props
  }, ref) => {
  const { t } = useTranslation();
  const className = combineClassNames('ButtonTemplate', {
    'ButtonTemplate--add': !item,
    'ButtonTemplate--clickable': !!item,
  });

  return (
    <div
      {...props}
      ref={ref}
      className={className}
      onClick={(e) => {
          // Only call onTemplateClick if explicitly provided
          if (onTemplateClick) {
            onTemplateClick(item?.id);
          }
          // Call onClick from Radix UI (for opening modal) if it exists
          if (onClick) {
            onClick(e);
          }
        }}
      role="button"
    >
      <div
        className="ButtonTemplate__Card"
        style={{ backgroundColor: item?.color || item?.background_color }}
      >
        {(item && (
          <img
            alt={item.title}
            src={item.icon || item.thumbnail_path}
          />
          )) || (
            <Icon type="add" />
        )}
      </div>
      <div className="ButtonTemplate__Title">
        {(item && `+ ${item.title}`) || t(title)}
      </div>
    </div>
  );
  }
);

ButtonTemplate.displayName = 'ButtonTemplate';

export default ButtonTemplate;
